import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const waLink = (number, text) =>
  `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
